module.exports = __webpack_public_path__ + "img/HCPconnect.9b494988.svg";